// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"MessageModal_contentWrapper__39o7y","message":"MessageModal_message__L82CA","checkIcon":"MessageModal_checkIcon__1Qlca"};